import React, { useState } from 'react';
import { HexagonIcon, XIcon } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsModal } from './TermsModal';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showCareersModal, setShowCareersModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  return <>
      <footer className="bg-navy border-t border-white/10 pt-16 pb-8" data-id="element-72">
        <div className="max-w-7xl mx-auto px-6" data-id="element-73">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-74">
            {/* Brand Column */}
            <div className="md:col-span-1" data-id="element-75">
              <div className="flex items-center gap-2 mb-4" data-id="element-76">
                <img src="https://cdn.magicpatterns.com/uploads/4MwpWUASBxAuCwNdk51yeZ/fiqis3.png" alt="FIQIS Logo" className="w-7 h-7 object-contain" data-id="element-77" />
                <span className="text-xl font-bold tracking-wider text-white" data-id="element-78">
                  FIQIS
                </span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-79">
                White-label financial infrastructure platform built for banks
                and credit unions to modernize securely.
              </p>
            </div>

            {/* Links Columns */}
            <div data-id="element-80">
              <h4 className="text-white font-semibold mb-4" data-id="element-81">Platform</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-82">
                <li data-id="element-83">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-84">
                    Integration Layer
                  </a>
                </li>
                <li data-id="element-85">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-86">
                    Customer Intelligence
                  </a>
                </li>
                <li data-id="element-87">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-88">
                    Micro-Lending
                  </a>
                </li>
                <li data-id="element-89">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-90">
                    Embedded P2P
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-91">
              <h4 className="text-white font-semibold mb-4" data-id="element-92">Company</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-93">
                <li data-id="element-94">
                  <a href="#about" className="hover:text-teal transition-colors" data-id="element-95">
                    About Us
                  </a>
                </li>
                <li data-id="element-96">
                  <button onClick={() => setShowCareersModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-97">
                    Careers
                  </button>
                </li>
                <li data-id="element-98">
                  <a href="#" className="hover:text-teal transition-colors" data-id="element-99">
                    Newsroom
                  </a>
                </li>
                <li data-id="element-100">
                  <a href="mailto:arthur@fiqis.com" className="hover:text-teal transition-colors" data-id="element-101">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-102">
              <h4 className="text-white font-semibold mb-4" data-id="element-103">Legal</h4>
              <ul className="space-y-3 text-sm text-gray-400" data-id="element-104">
                <li data-id="element-105">
                  <button onClick={() => setShowPrivacyModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-106">
                    Privacy Policy
                  </button>
                </li>
                <li data-id="element-107">
                  <button onClick={() => setShowTermsModal(true)} className="hover:text-teal transition-colors text-left" data-id="element-108">
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-109">
            <p className="text-sm text-gray-500" data-id="element-110">
              &copy; {currentYear} Financial Quantum Intelligence Systems. All
              rights reserved.
            </p>
            <div className="flex gap-4 text-sm text-gray-500" data-id="element-111">
              <span data-id="element-112">arthur@fiqis.com</span>
              <span data-id="element-113"></span>
            </div>
          </div>
        </div>
      </footer>

      {/* Careers Modal */}
      {showCareersModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={() => setShowCareersModal(false)} data-id="element-114">
          <div className="bg-slate border border-white/10 rounded-2xl p-8 max-w-md mx-4 text-center shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-115">
            <div className="mb-6" data-id="element-116">
              <div className="w-12 h-12 rounded-full bg-teal/10 border border-teal/20 flex items-center justify-center mx-auto mb-4" data-id="element-117">
                <XIcon className="w-6 h-6 text-teal" data-id="element-118" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-119">
                No Open Positions
              </h3>
              <p className="text-gray-400" data-id="element-120">
                Sorry, we are not currently hiring. Please check back later for
                future opportunities.
              </p>
            </div>
            <button onClick={() => setShowCareersModal(false)} className="bg-teal hover:bg-teal-400 text-navy font-semibold px-6 py-2.5 rounded-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)]" data-id="element-121">
              Close
            </button>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} data-id="element-122" />

      {/* Terms of Service Modal */}
      <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} data-id="element-123" />
    </>;
}